enum Tab {
    Grid,
    Formulaire
}

export default Tab